<template>
  <div
    class="ivu-select ivu-select-single"
    :class="{ 'ivu-select-open': isOpen, 'ivu-select-disabled': isDisabled }"
  >
    <div
      class="ivu-select-selection"
      @click="toggleOpen"
      :tabindex="isDisabled ? -1 : 0"
      :aria-disabled="isDisabled"
      :aria-expanded="isOpen"
    >
      <div
        class="ivu-select-selected-value"
        :class="{ 'ivu-select-placeholder': !selectedValue }"
      >
        {{ selectedValue || placeholder }}
      </div>
      <i class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"></i>
    </div>
    <div class="ivu-select-dropdown" v-if="isOpen">
      <ul class="ivu-select-dropdown-list">
        <li
          v-for="(option, index) in options"
          :key="index"
          :class="{
            'ivu-select-item-selected': option.value === selectedValue,
          }"
          class="ivu-select-item"
          @click="selectOption(option)"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedValue: this.value,
      isDisabled: this.disabled,
    };
  },
  methods: {
    toggleOpen() {
      if (!this.isDisabled) {
        this.isOpen = !this.isOpen;
      }
    },
    selectOption(option) {
      this.selectedValue = option.value;
      this.isOpen = false;
      this.$emit("input", option.value);
    },
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    },
    disabled(newValue) {
      this.isDisabled = newValue;
    },
  },
};
</script>

<style lang="less" scoped>
.ivu-select {
  position: relative;
  width: 80px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  // border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
}
.ivu-select.ivu-select-open {
  border-color: #409eff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 1;
}
.ivu-select.ivu-select-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
.ivu-select .ivu-select-selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  border-radius: 4px !important;
  line-height: 1.5;
}
.ivu-select .ivu-select-arrow {
  font-size: 12px;
  margin-left: 6px;
  color: #999;
  transition: none;
}
.ivu-select.ivu-select-open .ivu-select-arrow {
  transform: rotate(180deg);
  position: relative;
  top: 0px;
}
.ivu-select .ivu-select-selected-value {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 7px !important;
  line-height: 32px;
}
.ivu-select .ivu-select-placeholder {
  color: #c5c8ce;
  opacity: .72;
}
.ivu-select .ivu-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-top: none;
  border-bottom-left-radius: 4px;
}
.ivu-select .ivu-select-dropdown-list {
  max-height: 200px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}
.ivu-select .ivu-select-item {
  padding: 6px 10px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s;
}
.ivu-select .ivu-select-item:hover {
  background-color: #f5f5f5;
}
.ivu-select .ivu-select-item-selected {
  color: #2d8cf0;
  background: #f3f3f3;
}

</style>
  